import { CloudEntry, validateCloudEntry } from "../../model/cloud/CloudEntry.js";
import { CloudNewDirectory } from "../../model/cloud/CloudNewDirectory.js";
import {
  Progress,
  Uploader,
  requestDeleteJson,
  requestGetJson,
  requestPostJson,
  uploadFiles
} from "../../../packages/fetcher/fetcherFunctions.js";
import { createArrayValidator } from "../../../packages/validator/validator.js";

/**
 * Retrieves directory entries.
 */
export const getDirectoryEntries = async (directory: string) => {
  const entries = await requestGetJson<CloudEntry[]>(`/api/cloud/directory?directory=${directory}`);
  return createArrayValidator<CloudEntry>(validateCloudEntry)(entries);
};

/**
 * Uploads files to the directory.
 */
export const uploadDirectoryFiles = async (
  directory: string,
  formData: FormData,
  setUploader?: (uploader: Uploader) => void,
  handleProgress?: (progress: Progress) => void
) => {
  await uploadFiles(`/api/cloud/directory?directory=${directory}`, formData, setUploader, handleProgress);
};

/**
 * Creates new directory at the destination.
 */
export const createNewDirectory = async (destination: string, directoryName: string) => {
  await requestPostJson<void, CloudNewDirectory>("/api/cloud/create-directory", {
    destination,
    directoryName
  });
};

/**
 * Removes the file or directory.
 */
export const deletePath = async (path: string) => {
  await requestDeleteJson(`/api/cloud/path?path=${path}`);
};
